module.exports = __webpack_public_path__ + "static/key-phantom-e51a20b38c34bc0707f0281b275cd32f.webp";